module.exports = __webpack_public_path__ + "static/media/tablet-angle.c115ca55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/tablet-angle.png
// module id = 370
// module chunks = 0